import React, {useState} from "react";

import AirlineLogoText from './components/airlineLogoText';
import AirlineLogoImg from './components/airlineLogoImg/AirlineLogoImg';
import {ITicketDetailsWithTerms} from 'gui/components/editors/flightEditor/components/ticketDetailsForm';
import {IAirline} from 'data/interfaces/products';


interface IAirlineLogoProps {
  ticketDetails?: ITicketDetailsWithTerms;
  flightCompany?: IAirline;
  style: any;
  flip: boolean;
  className?: string;
}

const onError = (ev) => {
  ev.target.src = 'some default image url'
}

const AirlineLogo = (props: IAirlineLogoProps) => {
  const [fallbackState, setFallback] = useState({});
  const flightCompany = props.flightCompany || ((props.flip && props.ticketDetails.destinationFlightCompany) ? props.ticketDetails.destinationFlightCompany : props.ticketDetails.originFlightCompany);
  if (flightCompany) {
    if (fallbackState[flightCompany.icao]) {
      return (<AirlineLogoText text={flightCompany.name ? flightCompany.name.slice(0, 30) : ''}/>);
    } else {
      return (
        <AirlineLogoImg
          className={props.className}
          icao={flightCompany.icao}
          title={flightCompany.name}
          style={props.style}
          onError={(e) => {
            setFallback({
              ...fallbackState,
              [flightCompany.icao]: true,
            });
          }}/>
      );
    }
  }
  return (null);
};

AirlineLogo.defaultProps = {
  ticketDetails: {},
  style: {},
  flip: false,
};

export default React.memo(AirlineLogo);
